import styled from 'foundations-theming/utils';

// A simple skeleton ui for text which is currently loading; shows a gray bar.
// It's approximately the height of average text in the current font size (0.8em),
// so it looks sort of like text when you squint.
//
//   <SkeletonText />
//   <SkeletonText width={80} />
//
// Reused from WorkflowsReactUI https://git.hubteam.com/HubSpot/WorkflowsReactUI/blob/master/static/js/platform/components/common/SkeletonText.js/
import { jsx as _jsx } from "react/jsx-runtime";
const getSize = value => typeof value === 'number' ? `${value}px` : value;
const StyledDiv = styled.div.withConfig({
  displayName: "SkeletonText__StyledDiv",
  componentId: "sc-1vq1jz2-0"
})(({
  inlineSize,
  theme
}) => {
  return {
    background: theme.color['fill-tertiary-default'],
    borderRadius: theme.borderRadius[300],
    display: 'inline-block',
    blockSize: '0.8em',
    inlineSize
  };
});
const SkeletonText = ({
  width = '6em'
}) => {
  return /*#__PURE__*/_jsx(StyledDiv, {
    inlineSize: getSize(width)
  });
};
export default SkeletonText;